import { customerService } from '../services';
import { toast } from 'react-hot-toast';
import { CustomerT } from '../types';

export const createCustomer = async (data: CustomerT) => {
  try {
    const res = await customerService.post('customers', data);
    return res.data;
  } catch (e: any) {
    throw new Error(e.response?.data || e.message);
  }
};

export const GetCustomer = async (id: string) => {
  try {
    const res = await customerService.get(`/customers/${id}`);
    return res.data;
  } catch (e: any) {
    throw new Error(e.response?.data || e.message);
  }
};

export const editCustomer = async (id: string, data: CustomerT) => {
  try {
    const res = await customerService.patch(`/customers/${id}`, data);
    return res.data;
  } catch (e: any) {
    throw new Error(e.response?.data || e.message);
  }
};
export const deleteCustomer = async (id: string) => {
  try {
    const res = await customerService.delete(`/customers/${id}`);
    return res.data;
  } catch (e: any) {
    throw new Error(e.response?.data || e.message);
  }
};
